var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#seat-star';
                    var viewUrl = 'svg/global.svg#view-seat-star';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 106 56',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };